import { ITracking } from '../../types/tracking';
import { TReduxActions } from '../../types/redux';

const SET_TRACKING_DATA_TYPE = 'tracking/setData';

export const TRACKING_DEFAULT_PARAMS: ITracking = {
  user: {},
  page: {
    pageType: 'HomeSuburban',
    siteType: 'desktop',
  },
};

export function trackingReducer(state: ITracking = TRACKING_DEFAULT_PARAMS, action: TReduxActions): ITracking {
  switch (action.type) {
    case SET_TRACKING_DATA_TYPE:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
}

export type TSetTrackingDataType = 'tracking/setData';

export interface ISetTrackingData {
  type: TSetTrackingDataType;
  payload: ITracking;
}

export function setTrackingData(tracking: ITracking): ISetTrackingData {
  return {
    type: SET_TRACKING_DATA_TYPE,
    payload: tracking,
  };
}
